import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function UserGuard({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <LoadingShell />;
  if (!user) return <Navigate to="/register" replace state={{ from: location }} />;
  return children;
}

export function AdminGuard({ children }) {
  const { admin } = useAuth();
  const location = useLocation();
  if (admin === undefined) return <LoadingShell />;
  if (!admin) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}

function LoadingShell() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: "radial-gradient(ellipse 90% 50% at 50% 0%, #0a1829 0%, #060e1b 50%, #040812 100%)" }}
    >
      <div className="text-center">
        <div className="mx-auto w-24 h-24 rounded-full overflow-hidden border-2 border-cyan-400/60 shadow-[0_0_30px_rgba(34,211,238,0.45)] bg-[#050a18]">
          <img
            src="/brand/reddy-club-logo.png"
            alt="Reddy Club"
            className="w-full h-full object-contain"
            draggable={false}
          />
        </div>
        <div className="mt-4 font-display font-black text-2xl tracking-tight text-gold-static">REDDY CLUB</div>
        <div className="mt-1 text-[10px] uppercase tracking-[0.3em] text-cyan-200/80">Loading…</div>
      </div>
    </div>
  );
}
